import {URL_CONFIG} from '@/url_config';

const BASE_URL = URL_CONFIG.mi_url


const handleResponse = async (response) => {
    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP Error ${response.status}: ${errorText}`);
    }
    return response.json();
};

export const getImgMatch = async (reqData) => {
    const response = await fetch(`${BASE_URL}/mi_ai/get_img_match`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(reqData),
    });
    return handleResponse(response);
};